import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiNewsCardComponent } from './ui-news-card-community/ui-news-card-community.component';
import { RouterModule } from '@angular/router';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';

@NgModule({
  declarations: [UiNewsCardComponent],
  exports: [UiNewsCardComponent],
  imports: [CommonModule, RouterModule.forChild([]), SharedUtilsImageModule, SharedUtilsModule]
})
export class NewsUiNewsCardCommunityModule {}
